module.exports = __webpack_public_path__ + "img/shezhi.502a7482.png";